import pathToRegex from 'path-to-regexp'
import {clone, randomInt} from '../../utils'
import {buildIndex, filterByInx, sort} from '../../utils/vuexHelpers'
import {response} from './_response'
import * as spoofing from './_spoofing'

export {pathToRegex, clone, randomInt, buildIndex, filterByInx, sort}

/**
 * register list of requests on mock adapter
 * 
 * @param {MockAdapter} mockAdapter 
 * @param {number} delay 
 * @param {Array<object>} requests [{method, path, action}, ...]
 */
export function mockRequests({mockAdapter, delay, middlewares, requests}) {
  requests.forEach(requestOptions => {
    const [methodOriginal, pathStr, action] = requestOptions;
    const method = methodOriginal.toLowerCase();
    
    const onMethod = 'on' + method.charAt(0).toUpperCase() + method.slice(1);
    let pathKeys = [];
    let path = pathToRegex(pathStr, pathKeys);

    spoofing.addRequest(method, path);

    mockAdapter[onMethod](path).reply(config => response({
      delay: (typeof delay == 'function') ? delay(requestOptions) : delay,
      action() {

        const data = (config.data && JSON.parse(config.data)) || {};
        const routeParams = path.exec(config.url);
        let route = {};

        // route params
        pathKeys.forEach((key, index) => {
          route[key.name] = routeParams[index + 1];
        });

        // query params
        const params = config.params || {};

        // ======================================
        // middlewares pipeline
        // --------------------------------------
        const pipeline = [
          (request) => clone(action(clone(request)))
        ];

        for (let index = middlewares.length-1; index >= 0; index--) {
          pipeline.unshift((request) => middlewares[index](request, pipeline[index+1]))
        }

        return pipeline[0]({route, params, data, config});        
        // ======================================
      }
    }));
  });
}
